import { MockedResponse } from '@apollo/client/testing';

import { AppointmentMode } from '__generated__/globalTypes';
import { GET_COUNSELLORS } from './useGetCounsellors';
import type { getAvailableCounsellorsVariables } from './__generated__/getAvailableCounsellors';

export const mockAvailableCounsellors = [
  {
    id: 1,
    firstName: 'Alice',
    lastName: 'Smith',
    bio: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris interdum maximus dictum. Etiam vitae scelerisque elit. Pellentesque augue urna, facilisis elementum ex eu, feugiat finibus purus. Etiam vestibulum mauris eget pellentesque scelerisque. Sed pulvinar justo at magna cursus mattis. Maecenas a sapien quis tellus molestie mattis. Vestibulum ac neque vel justo feugiat mattis. Donec ac lacinia lorem, a eleifend elit. Vivamus non risus id velit cursus pharetra ac id augue. Quisque sit amet ante sagittis, tincidunt sapien quis, ultricies risus. Mauris congue tortor risus, in aliquam mi pulvinar vitae. Suspendisse congue purus augue, vel pretium ante mattis ultrices. Cras id molestie neque, sit amet pharetra nisl. Cras sit amet nisl vitae nunc condimentum laoreet eget eget tellus. Sed aliquet faucibus justo, non dapibus ex euismod ac. Nam posuere metus et nulla ultricies malesuada.<br/><br/><b>Language: </b>English',
    picture: 'alice.jpg',
    bookingTimes: {
      date: '2025-09-12',
      timeSlots: [
        {
          from: '14:00',
          to: '14:45',
        },
      ],
    },
  },
  {
    id: 2,
    firstName: 'Bob',
    lastName: 'Johnson',
    bio: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris interdum maximus dictum. Etiam vitae scelerisque elit. Pellentesque augue urna, facilisis elementum ex eu, feugiat finibus purus. Etiam vestibulum mauris eget pellentesque scelerisque. Sed pulvinar justo at magna cursus mattis. Maecenas a sapien quis tellus molestie mattis. Vestibulum ac neque vel justo feugiat mattis. Donec ac lacinia lorem, a eleifend elit. Vivamus non risus id velit cursus pharetra ac id augue. Quisque sit amet ante sagittis, tincidunt sapien quis, ultricies risus. Mauris congue tortor risus, in aliquam mi pulvinar vitae. Suspendisse congue purus augue, vel pretium ante mattis ultrices. Cras id molestie neque, sit amet pharetra nisl. Cras sit amet nisl vitae nunc condimentum laoreet eget eget tellus. Sed aliquet faucibus justo, non dapibus ex euismod ac. Nam posuere metus et nulla ultricies malesuada.<br/><br/><b>Language: </b>English',
    picture: 'bob.jpg',
    bookingTimes: {
      date: '2025-09-12',
      timeSlots: [
        {
          from: '13:00',
          to: '15:45',
        },
      ],
    },
  },
];

export const mockGetCounsellors: MockedResponse = {
  request: {
    query: GET_COUNSELLORS,
    variables: {
      date: '2025-01-01',
      times: ['11:00:00', '12:00:00', '14:30:00'],
      serviceId: '8', // Wellness Coaching
      emailAddress: 'user@example.com',
      filters: {
        appointmentMode: AppointmentMode.PHONE,
        languages: ['5'],
        timeZone: 'Europe/London',
      },
    } as getAvailableCounsellorsVariables,
  },
  result: {
    data: {
      availableCounsellors: {
        __typename: 'AvailableCounsellors',
        date: '2025-09-12',
        timeZone: 'London',
        counsellors: mockAvailableCounsellors,
      },
    },
  },
};
